import { defineComponent } from "vue";
import StepBox from "../../components/StepBox";
import InputText from "../../forms/InputText";
import InputCheckbox from "../../forms/InputCheckbox";
import Utils from "../../utils/Utils";
import Validator, { ValidationError } from "../../utils/Validator";
import InputSelect from "../../forms/InputSelect";
import UploadBox from "../../components/UploadBox";
import BlueInfoBox from "../../components/BlueInfoBox";
import Dialogs from "../../utils/Dialogs";
import Dialog from "../../utils/Dialog";
import UsageForm, { UsageInfo } from "../../components/UsageForm";
import Tracking from "../../utils/Tracking";
import LabeledInput from "../../components/LabeledInput";

export default defineComponent({
    components: {
        InputText,
        InputCheckbox,
        InputSelect,
        StepBox,
        UploadBox,
        LabeledInput,
        BlueInfoBox,
        Dialog,
        UsageForm,
    },

    template: `
        <StepBox class="StepFormProfile"
            :step="1"
            :currentstep="step"
            title="Dane do umowy"

            sticky="auto"

            :valid="valid"
            :back="true"
            :error="sent ? options.valid_invoice_error : null"

            @back="$emit('back')"
            @edit="$emit('goto', 1)"
            @next="onNext"
        >
            <div class="StepFormProfile__form">
                <div v-if="visible_upload" class="StepFormProfile__upload">
                    <p>Nadal możesz wgrać fakturę, a my uzupełnimy <b>formularz za Ciebie</b>.</p>

                    <UploadBox
                        :options="options"

                        :visible_next="false"

                        @next="onUploadNext"
                    />

                    <hr />
                </div>

                <h3 class="StepFormProfile__title-first">
                    Informacje o taryfie

                    <button type="button" class="StepFormProfile__help" @click="onHelp('usage')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                            <path d="M7.22656 12.4C7.22656 12.8267 7.57323 13.1734 7.9999 13.1734C8.42656 13.1734 8.77323 12.8267 8.77323 12.4C8.77323 11.9734 8.42656 11.6267 7.9999 11.6267C7.57323 11.6267 7.22656 11.9734 7.22656 12.4ZM8.29323 12.4C8.29323 12.56 8.1599 12.6934 7.9999 12.6934C7.8399 12.6934 7.70656 12.56 7.70656 12.4C7.70656 12.24 7.8399 12.1067 7.9999 12.1067C8.1599 12.1067 8.29323 12.24 8.29323 12.4Z" fill="#005537"/>
                            <path d="M13.0271 4.06662C12.7938 4.24662 12.7471 4.57995 12.9204 4.81329C13.7271 5.87995 14.1471 7.15995 14.1471 8.49995C14.1471 11.8866 11.3871 14.6466 8.00044 14.6466C4.61378 14.6466 1.85378 11.8866 1.85378 8.49995C1.85378 5.11329 4.61378 2.35329 8.00044 2.35329C9.23378 2.35329 10.4204 2.71329 11.4338 3.39995C11.6804 3.56662 12.0071 3.49995 12.1738 3.25995C12.3404 3.01329 12.2738 2.68662 12.0271 2.51995C10.8338 1.71329 9.44044 1.28662 7.99378 1.28662C4.02044 1.28662 0.787109 4.51995 0.787109 8.49995C0.787109 12.48 4.02044 15.7133 8.00044 15.7133C11.9804 15.7133 15.2138 12.48 15.2138 8.49995C15.2138 6.92662 14.7138 5.42662 13.7738 4.17329C13.5938 3.93995 13.2604 3.89329 13.0271 4.06662Z" fill="#005537"/>
                            <path d="M9.77414 8.02679C10.2475 7.55345 10.5075 6.92012 10.5075 6.21345C10.5075 4.82679 9.38081 3.70679 8.00081 3.70679C6.62081 3.70679 5.49414 4.83345 5.49414 6.21345C5.49414 6.50679 5.73414 6.74679 6.02747 6.74679C6.32081 6.74679 6.56081 6.50679 6.56081 6.21345C6.56081 5.42012 7.20747 4.76679 8.00081 4.76679C8.79414 4.76679 9.44081 5.41345 9.44081 6.25345C9.44081 6.64012 9.28747 7.00012 9.02081 7.27345L8.54747 7.74679C7.85414 8.44012 7.47414 9.36012 7.47414 10.3401C7.47414 10.6335 7.71414 10.8735 8.00747 10.8735C8.30081 10.8735 8.54081 10.6335 8.54081 10.3401C8.54081 9.64679 8.81414 8.99345 9.30081 8.50012L9.77414 8.02679Z" fill="#005537"/>
                        </svg>

                        <span>Pomoc</span>
                    </button>
                </h3>

                <LabeledInput type="kwh" label="Deklarowane zużycie" :modelValue="usage" unit="kWh/rok" :error="inputError('innerusage')" @update:modelValue="onUpdateValue('usage', $event)" @update:innerValue="innerusage = $event">
                    <template #edit_footer>
                        <button type="button" class="button button--primary StepFormProfile__calcbutton" @click="$refs.dialog_usage.show()">Oblicz zużycie</button>
                    </template>
                </LabeledInput>

                <LabeledInput type="list" label="Taryfa" :items="options.si_tariffs" :modelValue="tariff" :disabled="options.code != null" @update:modelValue="onTariffChange" :error="inputError('tariff')" />

                <BlueInfoBox v-if="$root.offer_revert" class="BlueInfoBox--float" :close="true" @close="$root.offer_revert = null">
                    <div>Zmieniliśmy Twoją ofertę na zgodną z zadeklarowaną taryfą. Obecna oferta to <b>{{ options.offer.fulltitle }}</b>.</div>

                    <div class="right">
                        <button type="button" class="BlueInfoBox__link" @click="onOfferRevert">Cofnij</button>
                    </div>
                </BlueInfoBox>

                <LabeledInput type="list" label="Okres rozliczeniowy" :items="si_periods" :modelValue="period" :error="inputError('period')" @update:modelValue="onUpdateValue('period', $event)" />
                <LabeledInput type="list" label="Okres wypowiedzenia umowy u obecnego sprzedawcy" :items="si_periods" :modelValue="noticeperiod" :error="inputError('noticeperiod')" @update:modelValue="onUpdateValue('noticeperiod', $event)" />
                <LabeledInput type="list" label="Rezerwowy sprzedawca energii" hint="Ustawowy" :items="options.si_vendors" :modelValue="spare_vendor" :error="inputError('spare_vendor')" @update:modelValue="onUpdateValue('spare_vendor', $event)" />

                <hr>

                <h3>Dane punktu poboru energii</h3>

                <InputText label="Numer PPE (Punkt Poboru Energii)" v-model="ppe" :required="true" :help="true" @help="onHelp('ppe')" :error="inputError('ppe')" />
                <InputSelect label="Operator Sieci (OSD)" hint="Wybierz" :items="options.si_osds" v-model="osd" :required="true" :help="true" @help="onHelp('osd')" :error="inputError('osd')" />
                <InputSelect label="Dotychczasowy sprzedawca" hint="Wybierz" :items="options.si_vendors" v-model="prev_vendor" :required="true" :error="inputError('prev_vendor')" />

                <hr class="mt-16 mb-20">

                <h3>Adres Punktu Poboru Energii</h3>

                <InputText label="Ulica" v-model="ppe_street" :required="true" :error="inputError('ppe_street')" />

                <div class="StepForm__group">
                    <InputText label="Numer budynku" v-model="ppe_buildingno" :required="true" :error="inputError('ppe_buildingno')" />
                    <InputText label="Numer mieszkania" v-model="ppe_apartmentno" :error="inputError('ppe_appartmentno')" />
                </div>

                <div class="StepForm__group23">
                    <InputText label="Kod pocztowy" v-model="ppe_zipcode" :required="true" :error="inputError('ppe_zipcode')" mask="00-000" />
                    <InputText label="Miejscowość" v-model="ppe_city" :required="true" :error="inputError('ppe_city')" />
                </div>

                <hr class="mt-16 mb-20">

                <h3>Adres zamieszkania</h3>

                <InputCheckbox title="Taki sam jak adres Punktu Poboru Energii" v-model="billing_actice" />

                <template v-if="!billing_actice">
                    <InputText label="Ulica" v-model="billing_street" :required="true" :error="inputError('billing_street')" />

                    <div class="StepForm__group">
                        <InputText label="Numer budynku" v-model="billing_buildingno" :required="true" :error="inputError('billing_buildingno')" />
                        <InputText label="Numer mieszkania (opcjonalnie)" v-model="billing_apartmentno" :error="inputError('billing_appartmentno')" />
                    </div>

                    <div class="StepForm__group23">
                        <InputText label="Kod pocztowy" v-model="billing_zipcode" :required="true" mask="00-000" :error="inputError('billing_zipcode')" />
                        <InputText label="Miejscowość" v-model="billing_city" :required="true" :error="inputError('billing_city')" />
                    </div>
                </template>

                <hr class="mt-16 mb-20">

                <h3>Adres korespondencyjny</h3>

                <InputCheckbox title="Taki sam jak adres zamieszkania" v-model="otheraddress_active" />

                <template v-if="!otheraddress_active">
                    <InputText label="Ulica" v-model="otheraddress_street" :required="true" :error="inputError('otheraddress_street')" />

                    <div class="StepForm__group">
                        <InputText label="Numer budynku" v-model="otheraddress_buildingno" :required="true" :error="inputError('otheraddress_buildingno')" />
                        <InputText label="Numer mieszkania (opcjonalnie)" v-model="otheraddress_apartmentno" :error="inputError('otheraddress_apartmentno')" />
                    </div>

                    <div class="StepForm__group23">
                        <InputText label="Kod pocztowy" v-model="otheraddress_zipcode" :required="true" mask="00-000" :error="inputError('otheraddress_zipcode')" />
                        <InputText label="Miejscowość" v-model="otheraddress_city" :required="true" :error="inputError('otheraddress_city')" />
                    </div>
                </template>
            </div>

            <Dialog ref="dialog_usage" class="Dialog--UsageForm" title="Pomoc" header="Kalkulator zużycia">
                <UsageForm
                    :initialusage="options.usage"

                    @usage="onUsageChange"
                />
            </Dialog>
        </StepBox>
    `,

    emits: [
        'next',
        'back',
        'goto',
    ],

    props: {
        /** @var OrderJson */
        options: { type: Object, required: true },
        step: { type: Number, required: true },

        visible_upload: { type: Boolean, default: false },
    },

    data() {
        return {
            osd: null,
            ppe: null,

            ppe_street: null,
            ppe_buildingno: null,
            ppe_apartmentno: null,
            ppe_zipcode: null,
            ppe_city: null,

            billing_actice: null,
            billing_street: null,
            billing_buildingno: null,
            billing_apartmentno: null,
            billing_zipcode: null,
            billing_city: null,

            otheraddress_active: null,
            otheraddress_street: null,
            otheraddress_buildingno: null,
            otheraddress_apartmentno: null,
            otheraddress_zipcode: null,
            otheraddress_city: null,

            innerusage: null,
            usage: null,
            tariff: null,
            prev_vendor: null,
            spare_vendor: null,
            period: null,
            noticeperiod: null,

            sent: false,
        };
    },

    computed: {
        si_periods() {
            const result = [];

            result.push({ id: 1, label: '1 miesiąc' });
            result.push({ id: 2, label: '2 miesiące' });
            result.push({ id: 6, label: '6 miesięcy' });
            result.push({ id: 12, label: '12 miesięcy' });

            return result;
        },

        valid() {
            try {
                Validator.assertNumber(this.usage);

                this.period && Validator.assertNumber(this.period);
                this.noticeperiod && Validator.assertNumber(this.noticeperiod);

                Validator.assertPpe(this.ppe);
                Validator.assertRequired(this.osd);
                Validator.assertRequired(this.prev_vendor);

                Validator.assertRequired(this.ppe_street);
                Validator.assertRequired(this.ppe_buildingno);
                Validator.assertZipCode(this.ppe_zipcode);
                Validator.assertRequired(this.ppe_city);

                if (!this.billing_actice) {
                    Validator.assertRequired(this.billing_street);
                    Validator.assertRequired(this.billing_buildingno);
                    Validator.assertZipCode(this.billing_zipcode);
                    Validator.assertRequired(this.billing_city);
                }

                if (!this.otheraddress_active) {
                    Validator.assertRequired(this.otheraddress_street);
                    Validator.assertRequired(this.otheraddress_buildingno);
                    Validator.assertRequired(this.otheraddress_zipcode);
                    Validator.assertRequired(this.otheraddress_city);
                }

                return true;
            } catch (e) {
                return false;
            }
        },
    },

    created() {
        this.setData();
    },

    watch: {
        options() {
            this.setData();
        },
    },

    methods: {
        inputError(field: string) {
            try {
                field == 'ppe_street' && Validator.assertRequired(this.ppe_street);
                field == 'ppe_buildingno' && Validator.assertRequired(this.ppe_buildingno);
                field == 'ppe_zipcode' && Validator.assertZipCode(this.ppe_zipcode);
                field == 'ppe_city' && Validator.assertRequired(this.ppe_city);

                if (!this.billing_actice) {
                    field == 'billing_street' && Validator.assertRequired(this.billing_street);
                    field == 'billing_buildingno' && Validator.assertRequired(this.billing_buildingno);
                    field == 'billing_zipcode' && Validator.assertZipCode(this.billing_zipcode);
                    field == 'billing_city' && Validator.assertRequired(this.billing_city);
                }

                if (!this.otheraddress_active) {
                    field == 'otheraddress_street' && Validator.assertRequired(this.otheraddress_street);
                    field == 'otheraddress_buildingno' && Validator.assertRequired(this.otheraddress_buildingno);
                    field == 'otheraddress_zipcode' && Validator.assertZipCode(this.otheraddress_zipcode);
                    field == 'otheraddress_city' && Validator.assertRequired(this.otheraddress_city);
                }

                field == 'innerusage' && Validator.assertNumber(this.innerusage?.toString());
                field == 'usage' && Validator.assertNumber(this.usage);
                field == 'tariff' && Validator.assertRequired(this.tariff);
                field == 'prev_vendor' && Validator.assertRequired(this.prev_vendor);
                field == 'osd' && Validator.assertRequired(this.osd);
                field == 'ppe' && Validator.assertPpe(this.ppe);

                switch (field) {
                    // case 'usage':
                    //     this.usage && Validator.assertNumber(this.usage);
                    //     break;

                    case 'period':
                        this.period && Validator.assertNumber(this.period);
                        break;

                    case 'noticeperiod':
                        this.noticeperiod && Validator.assertNumber(this.noticeperiod);
                        break;
                }
            } catch (e) {
                if (e instanceof ValidationError) {
                    return e.message;
                }

                return 'Błędny format pola';
            }
        },

        setData() {
            this.osd = this.options.osd;
            this.ppe = this.options.ppe;

            this.ppe_street = this.options.ppe_street;
            this.ppe_buildingno = this.options.ppe_buildingno;
            this.ppe_apartmentno = this.options.ppe_apartmentno;
            this.ppe_zipcode = this.options.ppe_zipcode;
            this.ppe_city = this.options.ppe_city;

            this.billing_active = !this.options.billing_active;
            this.billing_street = this.options.billing_street;
            this.billing_buildingno = this.options.billing_buildingno;
            this.billing_apartmentno = this.options.billing_apartmentno;
            this.billing_zipcode = this.options.billing_zipcode;
            this.billing_city = this.options.billing_city;

            this.otheraddress_active = !this.options.other_active;
            this.otheraddress_street = this.options.other_street;
            this.otheraddress_buildingno = this.options.other_buildingno;
            this.otheraddress_apartmentno = this.options.other_apartmentno;
            this.otheraddress_zipcode = this.options.other_zipcode;
            this.otheraddress_city = this.options.other_city;

            this.usage = this.options.usage;
            this.innerusage = this.usage;
            this.tariff = this.options.tariff;
            this.prev_vendor = this.options.prev_vendor;
            this.spare_vendor = this.options.spare_vendor;
            this.usage = this.options.usage?.toString();
            this.period = this.options.period?.toString();
            this.noticeperiod = this.options.noticeperiod?.toString();
        },

        onHelp(type: string) {
            switch (type) {
                case 'usage':
                    Dialogs.showModal({
                        class: 'Dialog--help-usage',

                        title: 'Pomoc',
                        header: 'Deklarowane zużycie',
                        message: `
                            <p>Deklarowane zużycie to ilość energii elektrycznej, którą prognozujesz zużyć w ciągu roku, wyrażona w kilowatogodzinach (kWh). Wprowadzenie tego parametru pomoże dostosować ofertę do Twoich potrzeb i oszacować przyszłe koszty.</p>

                            <p class="Dialog__hint"><b>Porada:</b> Średnio gospodarstwo domowe zużywa około 2000-3000 kWh rocznie, ale jeśli korzystasz z ogrzewania elektrycznego lub masz wiele energochłonnych urządzeń, zużycie może być wyższe</p>
                        `,
                    });
                    break;

                case 'ppe':
                    Dialogs.showModal({
                        class: 'Dialog--help-ppe',

                        title: 'Pomoc',
                        header: 'PPE - Punkt Poboru Energii',
                        message: `
                            <p><b>PPE, czyli Punkt Poboru Energii</b>, to unikalny numer identyfikacyjny przypisany do konkretnego miejsca, w którym pobierana jest energia elektryczna.</p>
                            <p>Służy do jednoznacznego określenia lokalizacji (adresu) odbioru energii, co jest przydatne przy rozliczeniach i w przypadku zmiany dostawcy energii.</p>

                            <p class="Dialog__hint">
                                <b>Numer PPE</b> składa się zazwyczaj z 16 lub 20 cyfr i jest unikalny dla każdego punktu poboru energii.<br><br>
                                PPE znajdziesz na rachunku za prąd, najczęściej w górnej części dokumentu lub w sekcji dotyczącej szczegółów umowy.
                            </p>
                        `,
                    });
                    break;

                case 'osd':
                    Dialogs.showModal({
                        class: 'Dialog--help-osd',

                        title: 'Pomoc',
                        header: 'OSD - Operator Systemu Dystrybucyjnego',
                        message: `
                            <p><b>Operator Systemu Dystrybucyjnego</b> (OSD) to firma odpowiedzialna za przesyłanie energii elektrycznej do Twojego domu lub firmy.</p>
                            <p>OSD zarządza siecią energetyczną, utrzymuje linie przesyłowe oraz dba o to, aby prąd docierał do Ciebie bez zakłóceń.</p>
                            <p>OSD jest przypisany do Twojej lokalizacji i nie można go zmienić, nawet jeśli zmieniasz dostawcę energii elektrycznej.</p>

                            <p class="Dialog__hint">
                                <b>Numer OSD</b> to unikalny identyfikator Twojego Operatora Systemu Dystrybucyjnego, który pomaga w szybkiej identyfikacji odpowiedzialnej firmy dystrybucyjnej w Twojej lokalizacji.
                            </p>
                        `,
                    });
                    break;
            }
        },

        async onUsageChange(info: UsageInfo) {
            await Utils.setCart('calc', {
                usage: info.usage,
                size: info.size,
                type: info.type,
            });

            this.usage = this.options.usage;

            this.$refs.dialog_usage.close();
        },

        async onUploadNext() {
            if (!this.options.offer) {
                this.$emit('upload');
            }
        },

        async onTariffChange(tariff: string) {
            const prevofferid = this.options.offer?.id;

            try {
                await this.sendValues(false);

                const r = await Utils.setCart('tariff', {
                    tariff: tariff,
                });

                if (prevofferid != this.options.offer?.id) {
                    this.$root.offer_revert = prevofferid;
                }
            } catch (e) {
                console.error(e);
            }
        },

        async onUpdateValue(type: string, value) {
            switch (type) {
                case 'usage':
                    this.innerusage = value;
                    this.usage = value;
                    break;

                case 'period':
                    this.period = value;
                    break;

                case 'noticeperiod':
                    this.noticeperiod = value;
                    break;

                case 'spare_vendor':
                    this.spare_vendor = value;
                    break;
            }

            await this.sendValues();
        },

        async onOfferRevert() {
            const r = await Utils.setCart('offer', {
                offer_id: this.$root.offer_revert,
            });

            this.$root.offer_revert = null;
        },

        async sendValues(setoptions: boolean = true) {
            await Utils.setCart('invoice', {
                osd: this.osd,
                ppe: this.ppe,

                ppe_active: true,
                ppe_street: this.ppe_street,
                ppe_buildingno: this.ppe_buildingno,
                ppe_apartmentno: this.ppe_apartmentno,
                ppe_zipcode: this.ppe_zipcode,
                ppe_city: this.ppe_city,

                billing_active: this.billing_active,
                billing_street: this.billing_street,
                billing_buildingno: this.billing_buildingno,
                billing_apartmentno: this.billing_apartmentno,
                billing_zipcode: this.billing_zipcode,
                billing_city: this.billing_city,

                other_active: this.otheraddress_active,
                other_street: this.otheraddress_street,
                other_buildingno: this.otheraddress_buildingno,
                other_apartmentno: this.otheraddress_apartmentno,
                other_zipcode: this.otheraddress_zipcode,
                other_city: this.otheraddress_city,

                prev_vendor: this.prev_vendor,
                spare_vendor: this.spare_vendor,
                usage: this.usage,
                period: this.period,
                noticeperiod: this.noticeperiod,
            }, setoptions);
        },

        async onNext() {
            this.sent = false;
            await this.sendValues();
            this.sent = true;

            Tracking.doEvent('click_personaldata_step1');

            this.$emit('next');
        },
    },
});
